import * as React from "react";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Button, Icon, Paper } from "@mui/material";
import ViewFileRepositoryList from "../../pages/FileRepository/Component/ViewFileRepositoryList";
import { RiskManagementForm } from "../../pages/RiskManagement/Component/RiskManagementForm";
import ProtectedRoute from "../ProtectedRoute";
import JSI from "../../assets/JSI.png";
import { Breadcrumb } from "../Breadcrumb";

//Routes
import { Routes, Route, useLocation } from "react-router-dom";
import { DashBoard } from "../../pages/Dashboard";
import { Policies } from "../../pages/Policies";
import { FileRepository } from "../../pages/FileRepository";
import { PolicyForm } from "../../pages/Policies/PolicyForm";
import { IncidentResponsePlan } from "../../pages/IncidentResponsePlan";

import { IncidentResponsePlanForm } from "../../pages/IncidentResponsePlan/IncidentResponsePlanForm";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { Stack } from "@mui/material";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import useCurrentComponentLocation from "./Utils/UserCurrentComponentLocation";
import { Avatar } from "@mui/material";
import {
  HomeIcon,
  AppsIcon,
  UserIcon,
  HelpIcon,
} from "../../assets/NavBarToggleIcon";
import { Drawer, DrawerHeader } from "./Utils/DrawerStyles";
import { RiskAssesment } from "../../pages/RiskAssesment";
import CSRiskAssesmentForm from "../../pages/RiskAssesment/component/CSRiskAssesmentForm";
// import RiskAssesmentControl from "../../pages/RiskAssesment/component/RiskAssesmentMenu";
import RiskAssesmentControls from "../../pages/RiskAssesment/Controls";
import SupplyChainAssesmentRiskForm from "../../pages/RiskAssesment/component/RiskForm1/SupplyChainRiskForm";
import Vulnerability from "../../pages/RiskAssesment/Vulnerability";
import { IncidentResponsePlaybook } from "../../pages/IncidentResponsePlaybook";
import { IncidentResponsePlaybookForm } from "../../pages/IncidentResponsePlaybook/IncidentResponsePlaybookForm";
import { RiskManagement } from "../../pages/RiskManagement";
import { Appendix } from "../../pages/RiskManagement/Appendix";
import { ApendixForm } from "../../pages/RiskManagement/Appendix/AppendixForm";
import { IncidentResponseTests } from "../../pages/IncidentResponseTests";
import { IncidentResponseTestForm } from "../../pages/IncidentResponseTests/IncidentResponseTestForm";

import { RiskManagementProvider } from "../../context/RiskManagement/RiskManagementContext";
import { useCompanyProfileContext } from "../../context/CompanyProfile/CompanyProfileContext";
import { CompanyProfilePage } from "../../pages/CompanyProfilePage";
import ThreatSource from "../../pages/RiskAssesment/ThreatSource";
import AuthContext, { useAuthContext } from "../../context/auth/AuthContext";
import { useUserContext } from "../../context/auth/UserContext";
import axios from "axios";
import { useRef } from "react";
import { getCompanyProfileByUserId } from "../../pages/CompanyProfilePage/helper";
import { UserRoleSetup } from "../../pages/UserRoleSetup";
const apps = [
  "Policies",
  "Risk Assessment",
  "Risk Management",
  "Incident Response Plan",
  "File Repository",
];
const user = ["Company Profile Page", "User Role Setup", "Switch Account", "Logout"];
const supportEmail = "mailto:Jsi-Velocity_support@jsitel.com";

export default function MiniDrawer() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasFetched = useRef(false);
  const locationInfo = useCurrentComponentLocation();
  const { } = useCompanyProfileContext();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [openNestedList, setOpenNestedList] = React.useState<
    Record<string, boolean>
  >({});
  const [view, setView] = React.useState("Home");
  const [listValue, setListValue] = React.useState<string[]>();
  const [selectedIcon, setSelectedIcon] = React.useState("Home");
  const [name, setName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const authContext = React.useContext(AuthContext);
  const { portalUser, isPortalAuthenticated, logout } = authContext;
  const {
    userId,
    companyLogo,
    isAppLoading,
    companyProlifeList,
    setCompanyProfileID,
    setIsApploading,
    setIsSwitchAccountClick,
    setIsLogoutClick,
    setCompanyProfileList,
    isLogoutClick,
    noCompaniesUnderClient,
    isAccessFetching,
    noRoleAssigned,
    isSwitchAccountClick,
    companyProfileID,
    userAccess,
  } = useUserContext();
  const handleLogout = (e?: any) => {
    if (e) e.preventDefault();
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    axios.get("/logout", config).then((response) => {
      console.log("LOGGED OUT", response);
      if (logout) {
        logout();
        navigate("/");
      }
    });

    // localStorage.setItem('isApploading', JSON.stringify(false));
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("userAccess");
    localStorage.removeItem("companyProfileID");
    localStorage.removeItem("companyLogo");


    setIsLogoutClick(true);
    setIsApploading(false);
    // logout();
  };

  // const handleLogin = (e: any) => {
  //   window.location.href = "/login";
  //   console.log("Login");

  // };

  React.useEffect(() => {
    if (portalUser && portalUser?.email) {
      setName(portalUser.firstname || "");
      setLastName(portalUser.lastname || "");
      console.log("USER ACCOUNT2:", portalUser);
      // getUserRole(response1);
    } else {
      console.log("USER ACCOUNT0:", portalUser);
      setName("");
      setLastName("");
    }
  }, [portalUser?.email]);

  const handleNestedClick = (val: string) => {
    // console.log("handleNestedClick", "val", val);

    if (val === "Policies") {
      navigate("/policies");
      setOpen(false);
    } else if (val === "File Repository") {
      navigate("/file-repository");
      setOpen(false);
    } else if (val === "Risk Assessment") {
      navigate("/risk-assessment");
      setOpen(false);
    } else if (val === "Risk Management") {
      navigate("/risk-management");
      setOpen(false);
    } else if (val === "Incident Response Plan") {
      //If nested list clicked
      navigate("/incident-response-plan");
      setOpen(false);
      setOpenNestedList((prev) => ({ ...prev, [val]: !prev[val] }));
    } else if (val === "Company Profile Page") {
      navigate("/company-profile");
      setOpen(false);
    } else if (val === "User Role Setup") {
      navigate("/user-role-setup");
      setOpen(false);
    } else if (val === "Switch Account") {
      setIsSwitchAccountClick(true);
      setView("Home");
      setSelectedIcon("Home");
      navigate("/");
      setOpen(false);

    } else if (val === "Logout") {
      handleLogout();
      setOpen(false);
    }
  };

  const handleToggleChange = (
    event: React.MouseEvent<HTMLElement>,
    nextView: string
  ) => {
    // console.log("handleToggleChange event", event, "nextView", nextView);

    if (nextView !== "Home" && nextView === view) {
      setOpen(!open); // Close the drawer is same Toggle button clicked
      return; // Exit function early if no change in view
    }
    // Update view based on nextView

    setView(nextView);
    setSelectedIcon(nextView);
    if (nextView === "Home") {
      //Home toggle button clicked
      setView(nextView);
      navigate("/");
      setOpen(false);
    } else if (nextView === "Apps") {
      //Apps toggle button clicked
      setView(nextView);
      setListValue(apps);
      setOpen(true);
    } else if (nextView === "User") {
      //User toggle button clicked
      setView(nextView);
      setListValue(user);
      setOpen(true);
    } else if (nextView === "Help") {
      //Help toggle button clicked
      setView(nextView);
      setListValue([]);
      setOpen(false);
      navigate("/");
    }
  };
  const handleLogoClick = () => {
    setView("Home");
    setSelectedIcon("Home");
    navigate("/");
    setOpen(false);
  };
  React.useEffect(() => {
    if (locationInfo.viewCategory === "Apps") {
      setListValue(apps);
      setView(locationInfo.viewCategory);
      setSelectedIcon(locationInfo.viewCategory);
    } else if (locationInfo.viewCategory === "User") {
      setListValue(user);
      setView(locationInfo.viewCategory);
      setSelectedIcon(locationInfo.viewCategory);
    } else if (locationInfo.viewCategory === "Help") {
      setListValue([]);
      setView(locationInfo.viewCategory);
      setSelectedIcon(locationInfo.viewCategory);
    }
    //   else if (locationInfo.viewCategory === "Home") {
    //   setListValue(help);
    //   setView(locationInfo.viewCategory);
    //   setSelectedIcon(locationInfo.viewCategory);
    // }
  }, [locationInfo]);

  // const fetchCompaniesList = async () => {
  //   console.log("fetchCompaniesList", userId);
  //   const res = await getCompanyProfileByUserId(userId);
  //   setCompanyProfileList(res);
  // };
  // React.useEffect(() => {
  //   if (!hasFetched.current) {
  //     fetchCompaniesList();
  //   }
  // }, []);

  React.useEffect(() => {
    if (!userAccess || !companyProfileID) {
      navigate("/");
    }
  }, []);

  return (
    <Box sx={{ display: "flex" }}>
      <Drawer variant="permanent" open={open}>
        <Stack
          display="flex"
          direction="row"
          height="100vh"
          sx={{ backgroundColor: "#F1F6F9" }}
        >
          <Paper
            elevation={3}
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#FFFFFF",
            }}
          >
            {/* Adjust margin-bottom as needed */}
            <Grid direction="column" height="100%">
              <Grid xs={12} height="30%" display="flex" flexDirection="column">
                <DrawerHeader>
                  <img
                    onClick={handleLogoClick}
                    src={JSI}
                    alt="Logo"
                    style={{
                      width: "51px",
                      maxWidth: "46px",
                      alignSelf: "center",
                      margin: "16px 0",
                      cursor: "pointer",
                    }}
                  />
                </DrawerHeader>
              </Grid>
              <Grid
                height="70%"
                columnSpacing={10}
                xs={12}
                justifyContent="center"
              >
                <ToggleButtonGroup
                  orientation="vertical"
                  value={view}
                  exclusive
                  sx={{ borderRadius: "5px" }}
                  size="medium"
                >
                  <ToggleButton
                    sx={{
                      minHeight: 48,
                      justifyContent: "initial",
                      px: 2.5,
                      borderStyle: "none",
                      bgcolor: view === "Home" ? "#0066FF" : "transparent",
                      // '&:hover': {
                      //   bgcolor: "#0066FF",
                      //   '& .MuiSvgIcon-root': {
                      //     color: "white",
                      //   },
                      //   '& .MuiTypography-root': {
                      //     color: "white",
                      //   },
                      // },
                      "&.Mui-selected": {
                        bgcolor: "#0066FF",
                        "&:hover": {
                          bgcolor: "#0c83ff",
                        },
                        "& .MuiSvgIcon-root": {
                          color: "white",
                        },
                        "& .MuiTypography-root": {
                          color: "white",
                        },
                      },
                    }}
                    onChange={handleToggleChange}
                    disabled={isAppLoading || isAccessFetching}
                    value="Home"
                    aria-label="Home"
                  >
                    <Stack direction="column">
                      <HomeIcon
                        stroke={selectedIcon === "Home" ? "white" : "#292D32"}
                      />
                      <Typography sx={{ fontSize: "0.5rem" }}>Home</Typography>
                    </Stack>
                  </ToggleButton>
                  <ToggleButton
                    sx={{
                      minHeight: 48,
                      justifyContent: "initial",
                      px: 2.5,
                      borderStyle: "none",
                      "&.Mui-selected": {
                        bgcolor: "#0066FF",
                        "&:hover": {
                          bgcolor: "#0c83ff",
                        },
                        "& .MuiSvgIcon-root": {
                          color: "white",
                        },
                        "& .MuiTypography-root": {
                          color: "white",
                        },
                      },
                    }}
                    onChange={handleToggleChange}
                    value="Apps"
                    disabled={isAppLoading || isAccessFetching}
                    aria-label="Apps"
                  >
                    <Stack>
                      <AppsIcon
                        stroke={selectedIcon === "Apps" ? "white" : "#292D32"}
                      />
                      <Typography sx={{ fontSize: "0.5rem" }}>Apps</Typography>
                    </Stack>
                  </ToggleButton>
                  <ToggleButton
                    sx={{
                      minHeight: 48,
                      justifyContent: "initial",
                      px: 2.5,
                      borderStyle: "none",
                      "&.Mui-selected": {
                        bgcolor: "#0066FF",
                        "&:hover": {
                          bgcolor: "#0c83ff",
                        },
                        "& .MuiSvgIcon-root": {
                          color: "white",
                        },
                        "& .MuiTypography-root": {
                          color: "white",
                        },
                      },
                    }}
                    onChange={handleToggleChange}
                    value="User"
                    aria-label="User"
                  //disabled={isAppLoading || isAccessFetching}
                  >
                    <Stack>
                      <UserIcon
                        stroke={selectedIcon === "User" ? "white" : "#292D32"}
                      />
                      <Typography sx={{ fontSize: "0.5rem" }}>User</Typography>
                    </Stack>
                  </ToggleButton>
                  <ToggleButton
                    sx={{
                      minHeight: 48,
                      justifyContent: "initial",
                      px: 2.5,
                      borderStyle: "none",
                      "&.Mui-selected": {
                        bgcolor: "#0066FF",
                        "&:hover": {
                          bgcolor: "#0c83ff",
                        },
                        "& .MuiSvgIcon-root": {
                          color: "white",
                        },
                        "& .MuiTypography-root": {
                          color: "white",
                        },
                      },
                    }}
                    onChange={handleToggleChange}
                    href={supportEmail}
                    value="Help"
                    aria-label="Help"
                    disabled={isAppLoading || isAccessFetching}
                  >
                    <Stack>
                      <HelpIcon
                        stroke={selectedIcon === "Help" ? "white" : "#292D32"}
                      />
                      <Typography sx={{ fontSize: "0.5rem" }}>Help</Typography>
                    </Stack>
                  </ToggleButton>
                </ToggleButtonGroup>
              </Grid>
            </Grid>
          </Paper>

          {/* </Box> */}
          {/* </Paper> */}

          {open && (
            <>
              <Divider orientation="vertical" flexItem />
              <List
                sx={{ backgroundColor: "#F1F6F9" }}
                style={{
                  width: "100vh",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {listValue?.map((val) => (
                  <ListItem key={val} disablePadding sx={{ display: "block" }}>
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        justifyContent: "center",
                        px: 2.5,
                      }}
                      disabled={
                        (val === "Switch Account" &&
                          companyProlifeList.length === 1) || (val !== "Logout" && (isAppLoading || isAccessFetching || noRoleAssigned))
                      }
                      onClick={() => handleNestedClick(val)}
                    >
                      <ListItemText
                        primary={val}
                        sx={{ opacity: open ? 1 : 0 }}
                      />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </>
          )}
        </Stack>
      </Drawer>
      {/* <Box sx={{ flexGrow: 1, p: 3, backgroundColor: "#E4EBEF" }}> */}
      <Grid
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="stretch"
        sx={{
          minHeight: "100vh",
          width: "100%",
          // background: "#F1F2F6",
          flexGrow: 1,
          p: 2,
          backgroundColor: "#E4EBEF",
        }}
        component="main"
      >
        <Grid xs={12}>
          <Stack
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
          >
            <Breadcrumb />
            <Stack
              direction="row"
              spacing={1}
              justifyContent="center"
              alignItems="center"
            >
              {((!isAppLoading && !isAccessFetching && companyLogo !== null && !isSwitchAccountClick) || (companyLogo !== null && isSwitchAccountClick)) ? (
                <IconButton>
                  <Box>
                    <img
                      src={companyLogo}
                      alt=""
                      style={{ width: 36, height: 38 }}
                    />
                  </Box>
                </IconButton>
              ) : (null)}


              <Typography
                sx={{
                  fontWeight: "400", // corrected from "weight"
                  fontSize: "14px",
                  lineHeight: "20px",
                  letterSpacing: "1px",
                }}
              >
                {`${name} ${lastName}`}
              </Typography>
            </Stack>
          </Stack>
        </Grid>
        <Grid flexGrow={1} xs={12}>
          <Stack direction="column" alignContent="center" width="100%">
            {isLogoutClick && (
              <Typography
                sx={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  color: "gray",
                  textAlign: "center",
                }}
              >
                Logging out...
              </Typography>
            )}
            {isAccessFetching && (
              noRoleAssigned ? (
                <Typography
                  sx={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: "gray",
                    textAlign: "center",
                  }}
                >
                  No companies are associated with this user. Please contact your administrator.
                </Typography>
              ) : (
                <Typography
                  sx={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: "gray",
                    textAlign: "center",
                  }}
                >
                  Fetching user access...
                </Typography>
              )
            )}
            {isAppLoading && !isLogoutClick && (
              noCompaniesUnderClient ? (
                <Typography
                  sx={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: "gray",
                    textAlign: "center",
                  }}
                >
                  No companies are associated with this user. Please contact your administrator.
                </Typography>
              ) : (
                <Typography
                  sx={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: "gray",
                    textAlign: "center",
                  }}
                >
                  Fetching company list...
                </Typography>
              )
            )}
          </Stack>
          {!isAccessFetching && (
            <Routes>
              <Route path="/" element={<DashBoard />} />
              <Route path="/policies" element={<Policies />} />
              <Route path="/add-policy" element={<PolicyForm />} />
              <Route path="/file-repository" element={<FileRepository />} />
              <Route
                path="/incident-response-plan-form"
                element={<IncidentResponsePlanForm />}
              />
              <Route
                path="/incident-response-plan"
                element={<IncidentResponsePlan />}
              />

              <Route path="/risk-assessment" element={<RiskAssesment />} />
              <Route
                path="/cyber-security-assesment-form"
                element={<CSRiskAssesmentForm />}
              />
              <Route
                path="/risk-assessment-control"
                element={<RiskAssesmentControls />}
              />
              <Route
                path="/risk-assessment-vulnerability"
                element={<Vulnerability />}
              />
              <Route
                path="/risk-assessment-threat-source"
                element={<ThreatSource />}
              />
              <Route
                path="/incident-response-playbook"
                element={<IncidentResponsePlaybook />}
              />
              <Route
                path="/incident-response-playbook-form"
                element={<IncidentResponsePlaybookForm />}
              />

              <Route
                path="/incident-response-test"
                element={<IncidentResponseTests />}
              />

              <Route
                path="/incident-response-test-form"
                element={<IncidentResponseTestForm />}
              />

              <Route
                path="/view-file-repository-list"
                element={<ViewFileRepositoryList />}
              />
              <Route
                path="/supply-chain-risk-assessment-form"
                element={<SupplyChainAssesmentRiskForm />}
              />
              <Route
                path="/risk-management"
                element={
                  // <RiskManagementProvider>
                  <RiskManagement />
                  // </RiskManagementProvider>
                }
              />
              <Route
                path="/risk-management-form"
                element={
                  // <RiskManagementProvider>
                  <RiskManagementForm />
                  // </RiskManagementProvider>
                }
              />
              <Route
                path="/risk-management-appendix-form"
                element={
                  <ProtectedRoute>
                    {/* <RiskManagementProvider> */}
                    <ApendixForm />
                    {/* </RiskManagementProvider> */}
                  </ProtectedRoute>
                }
              />
              <Route
                path="/risk-management-appendix"
                element={
                  // <RiskManagementProvider>
                  <Appendix />
                  // </RiskManagementProvider>
                }
              />
              {/* <Route path="/risk-management-appendix-form" element={<ApendixForm />} /> */}
              <Route
                path="/company-profile"
                element={
                  // <RiskManagementProvider>
                  <CompanyProfilePage />
                  // </RiskManagementProvider>
                }
              />
              <Route
                path="/user-role-setup"
                element={
                  // <RiskManagementProvider>
                  <UserRoleSetup />
                  // </RiskManagementProvider>
                }
              />
            </Routes>
          )}
        </Grid>
      </Grid>
      {/* </Box> */}
    </Box >
  );
}
